import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getLocalFranchiseStore, getUserData } from "../../../utils/localStorage";
import AdminMenu from "../../AdminMenu";
import { getBrandStore } from "../../../services/StoreUsers/PostStoreUsers";

import {
  Bar,
} from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  RadarController,
  Tooltip,
  Title,
  Legend,
  RadialLinearScale,
} from "chart.js";
import { formatDateNew, localeDateEndDate, localeDateStartDate } from "../../../constants/DateUtil/DateUtil";
import { ProgressSpinner } from "primereact/progressspinner";
import { getStoreOrderByMonth } from "../../../services/DashboardAPI/DashboardApi";
import AnalyticsOverallRevenueSchedularModal from "../../AnalyticsOverallRevenueSchedularModal";

// Register components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  ArcElement,
  RadarController,
  Tooltip,
  Title,
  Legend,
  RadialLinearScale
);

const OrderSaleAnalyticsNew = () => {
  const navigate = useNavigate();

  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  const brandId = brandProfileData.id;
  const [brandStoreIdsData, setBrandStoreIdsData] = useState([]);

  const [monthlyOrderCount, setMonthlyOrderCount] = useState([]);
  const [monthlySaleCount, setMonthlySaleCount] = useState([]);
  const [loading, setLoading] = useState(false);

  let initialStartDate = new Date();
  initialStartDate.setDate(initialStartDate.getDate()); // subtract 7 days to current date

  // If orderFilterData is available, use its start and end dates
  const [startDate, setStartDate] = useState(new Date(initialStartDate));
  let initialEndDate = new Date();
  const [endDate, setEndDate] = useState(new Date(initialEndDate));
  const [analyticsOverallRevenueSchedularModalVisible, setAnalyticsOverallRevenueSchedularModalVisible] =
    useState(false);
  const [schedularDate, setSchedularDate] = useState({});

  const receiveDataFromSchedularModal = ({ newSchedular }) => {
    setSchedularDate(newSchedular);
    setInitialDateValue(newSchedular.startDate)
    setEndDate(newSchedular.endDate)
  };

  const handleCalendarModal = () => {
    setAnalyticsOverallRevenueSchedularModalVisible(true);
  };

  const fetchStoreOrders = (data) => {
    setLoading(true);
    getStoreOrderByMonth(brandId, data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;

          const monthlyTotalAmountArray = Res.map((item, index) => ({
            ...item,
            label: new Date(item.year, item.month - 1).toLocaleString('en-US', { month: 'short', year: 'numeric' }),
            value: item.totalSale,
          }));
          
          const monthlyOrderArray = Res.map((item, index) => ({
              ...item,
              label: new Date(item.year, item.month - 1).toLocaleString('en-US', { month: 'short', year: 'numeric' }),
              value: item.totalOrder,
          }));
 
          setMonthlyOrderCount(monthlyOrderArray);
          setMonthlySaleCount(monthlyTotalAmountArray);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };
  // If orderFilterData is available, use its start and end dates
  const initializeVariable = () => {
    setMonthlyOrderCount([]);
    setMonthlySaleCount([]);
  };

  const initialDate = new Date(startDate);
  initialDate.setMonth(initialDate.getMonth() - 6);
  initialDate.setDate(1); // Set the date to the 1st of the month

  // initialDate.setDate(initialDate.getDate() - 90);

  const [initialDateValue, setInitialDateValue] = useState(initialDate)

  useEffect(() => {
    initializeVariable();
    const fetchData = async () => {
      try {
        const response = await getBrandStore(brandId);
        if (!response.data.error) {
          const brandStoreData = response.data;
          const storeIds = brandStoreData.map((item) => item.id);
          setBrandStoreIdsData(storeIds);

          // const initialStartDate = new Date();
          // initialStartDate.setDate(initialStartDate.getDate() - 360);

          // const initialStartDate = userData.brandData.createdDate;
          // const initialEndDate = new Date();

          const data = {
            brandId: brandId,
            storeIds: storeIds,
            statusIn: [
              "BOOKED",
              "INPROCESS",
              "IN_WAREHOUSE",
              "PROCESSED",
              "DELIVERED",
              "DONE",
              "OUT_FOR_DELIVERY",
            ],
            recordType: "",
            // startDate: schedularDate?.startDate
            //   ? schedularDate.startDate
            //   : brandProfileData.createdDate !== null
            //   ? brandProfileData.createdDate
            //   : "2024-01-01T00:00:00Z",
            startDate: schedularDate?.startDate
                ? localeDateStartDate(new Date(schedularDate.startDate))
                : localeDateStartDate(new Date(initialDate)),
            endDate: schedularDate?.endDate ? localeDateEndDate(new Date(schedularDate.endDate)) : localeDateEndDate(new Date(endDate)),
          };
          fetchStoreOrders(data);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };

     const fetchFranchiseStore = async () => {
                     const franchiseStore = await getLocalFranchiseStore();
                     if (franchiseStore.franchiseStore !== null) {
                       const Res = franchiseStore.franchiseStore.filter((item) => item.status === "ACTIVE");
                       const storeIds = Res.map((item) => item.id);
                       const data = {
                         brandId: brandId,
                         storeIds: storeIds,
                         statusIn: [
                           "BOOKED",
                           "INPROCESS",
                           "IN_WAREHOUSE",
                           "PROCESSED",
                           "DELIVERED",
                           "DONE",
                           "OUT_FOR_DELIVERY",
                         ],
                         recordType: "",
                         startDate: schedularDate?.startDate
                           ? localeDateStartDate(new Date(schedularDate.startDate))
                           : localeDateStartDate(new Date(initialDate)),
                         endDate: schedularDate?.endDate
                           ? localeDateEndDate(new Date(schedularDate.endDate))
                           : localeDateEndDate(new Date(endDate)),
                       };
                       fetchStoreOrders(data);
                     }  
                   };
             

    if (userRole === "BY_FRANCHISE_ADMIN") {
      fetchFranchiseStore();
    } else {
      fetchData();
    }
  }, [schedularDate]);

  const chartsGradient = [
    "#006DFF",
    "#3BE9DE",
    "#ffa600",
    "#FF7F97",
    "#F6D173",
    "#009596",
    "#EC7A08",
    "#58508d",
    "#bc5090",
    "#ff6361",
    "#ffa600",
  ];

  const monthlyOrderData = monthlyOrderCount.map((item, index) => ({
    ...item,
    frontColor: chartsGradient[index % chartsGradient.length],
    gradientColor: chartsGradient[index % chartsGradient.length],
  }));

  const orderData = {
    labels: monthlyOrderData?.map((item) => item.label),
    datasets: [
      {
        label: "Orders",
        data: monthlyOrderData?.map((item) => item.value),
        backgroundColor: monthlyOrderData?.map((item) => item.gradientColor),
      },
    ],
  };

  const monthlyRevenueData = monthlySaleCount.map((item, index) => ({
    ...item,
    frontColor: chartsGradient[index % chartsGradient.length],
    gradientColor: chartsGradient[index % chartsGradient.length],
  }));

  const revenueData = {
    labels: monthlyRevenueData?.map((item) => item.label),
    datasets: [
      {
        label: "REVENUE",
        data: monthlyRevenueData?.map((item) => item.value),
        backgroundColor: monthlyRevenueData?.map((item) => item.gradientColor),
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: { legend: { position: "bottom" } },
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/AnalyticsList")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Overall Revenue
              </p>
            </div>
          </div>

          <div
            onClick={() => handleCalendarModal()}
            className="flex justify-content-center align-items-center cursor-pointer mr-4"
          >
            <img
              src={"Laundy_App_Icons_Gifs/Other_Icons/schedule.png"}
              style={{ width: 27 }}
              alt="schedule"
            />
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div class="flex flex-1 justify-content-center align-items-center">
       <p className=" text-2xl  font-bold ">Period - {formatDateNew(initialDateValue.toString())} - {formatDateNew(endDate).toString()}</p>
      </div>
      <div className="flex flex-1">
        <div className="flex-1">
          <div
            className="flex-1  surface-0"
            style={{ "--surface-0": "#EAEFF5" }}
          >
            <div className="flex justify-content-center mx-4">
              <div className="py-1">
                <p className=" text-2xl  font-bold ">MONTHLY ORDERS</p>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="flex flex-1 flex-column justify-content-center align-items-center">
              <ProgressSpinner />
              <p className="text-3xl font-bold">
              Loading Monthly Orders Data...
              </p>
            </div>
          ) : monthlyOrderData.length > 0 ? (
            <div>
              <div className="mx-4 my-3 flex justify-content-center">
                <div className="flex " style={{ height: 300 }}>
                <Bar data={orderData} options={chartOptions} />
                </div>
              </div>
            </div>
          ) : (
            <div className="flex flex-1 justify-content-center align-items-center">
              <p className="text-3xl font-bold">No Monthly Orders Found</p>
            </div>
          )}
        </div>
        <div className="flex-1">
          <div
            className="flex-1  surface-0"
            style={{ "--surface-0": "#EAEFF5" }}
          >
            <div className="flex justify-content-center mx-4">
              <div className="py-1">
                <p className=" text-2xl  font-bold ">MONTHLY REVENUE</p>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="flex flex-1 flex-column justify-content-center align-items-center">
              <ProgressSpinner />
              <p className="text-3xl font-bold">Loading Orders Revenue...</p>
            </div>
          ) : monthlyRevenueData.length > 0 ? (
            <div>
              <div className="mx-4 my-3 flex justify-content-center">
                <div className="flex " style={{ height: 300 }}>
                <Bar data={revenueData} options={chartOptions} />
                </div>
              </div>
            </div>
          ) : (
            <div className="flex flex-1 justify-content-center align-items-center">
              <p className="text-3xl font-bold">No Monthly Revenue Found</p>
            </div>
          )}
        </div>
      </div>
      <AnalyticsOverallRevenueSchedularModal
        analyticsOverallRevenueSchedularModalVisible={analyticsOverallRevenueSchedularModalVisible}
        setAnalyticsOverallRevenueSchedularModalVisible={setAnalyticsOverallRevenueSchedularModalVisible}
        sendDataToOrdersPage={receiveDataFromSchedularModal}
        type={"OverallRevenue"}
      />
      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default OrderSaleAnalyticsNew;
